// @flow
import React from 'react';
import { withRouter } from 'react-router-dom';
import { createRefetchContainer, graphql } from 'react-relay';
// material-ui
import Paper from 'material-ui/Paper';
import IconButton from 'material-ui/IconButton';
import IconContentAdd from 'material-ui/svg-icons/content/add';
import IconRemove from 'material-ui/svg-icons/navigation/close';
import IconPhoto from 'material-ui/svg-icons/image/photo';
// momentjs
import moment from 'moment';
// mutation
import * as MediaFileAddMutation from '../../mutations/MediaFileAddMutation';
import * as MediaFileEditMutation from '../../mutations/MediaFileEditMutation';
import { backendUrl, staticUrl } from '../../lib/config';
import modernEnvironment from '../../lib/RelayUtils';
// style
import { containerHeader, paperStyle, styles } from '../../lib/styles';
import './background.css';
// locale
import('moment/locale/ru');

type Props = {
    viewer: {
        mediaFiles: {
            mediaFiles: ?Array<Object>
        }
    }
};

type State = {
    filename: ?string,
    id: ?string,
    title: ?string,
};

class Background extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        const file = props.viewer.mediaFiles.mediaFiles[0];
        const isFile = file !== undefined;
        this.state = {
            filename: isFile ? file.filename : '',
            id: isFile ? file.id : '',
            title: isFile ? file.title : '',
        };
    }

    removeFile = () => {
        const sendData = {
            id: this.state.id,
            filename: this.state.filename,
            status: 'created',
            state: 'deleted',
            preview: '',
            type: 'image',
            title: this.state.title,
        };
        MediaFileEditMutation.commit(modernEnvironment, sendData, () => {
            if (sendData.id === this.state.id) {
                this.setState({
                    filename: '',
                    id: '',
                    title: '',
                });
            }
        });
    };

    uploadFile = (event) => {
        const file = event.target.files[0];
        if (file.type.indexOf('image/') !== 0) {
            return;
        }
        const sendDataAdd = {
            filename: file.name,
            status: 'created',
            state: 'deleted',
            type: 'wallpaper',
            title: '',
        };

        MediaFileAddMutation.commit(modernEnvironment, sendDataAdd, (error, mediaFileId: ?string) => {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('mediaFileId', mediaFileId);
            formData.append('orientation', 'original');

            fetch(`${backendUrl}/upload3`, {
                method: 'POST',
                body: formData,
            })
                .then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return response;
                })
                .then(resp => resp.json().then((data) => {
                    const date = moment(new Date()).format('DD MMMM YYYY');
                    if (data.filename) {
                        const sendData = {
                            id: mediaFileId,
                            filename: data.filename,
                            status: 'created',
                            state: 'available',
                            preview: '',
                            type: 'wallpaper',
                            title: `Фон для сайта от ${date}`,
                        };
                        MediaFileEditMutation.commit(modernEnvironment, sendData, () => {
                            if (this.state.id) {
                                this.removeFile();
                            }
                            this.setState({
                                id: mediaFileId,
                                filename: data.filename,
                                title: `Фон для сайта от ${date}`,
                            });
                        });
                    }
                    // return null;
                }))
                .catch((err) => {
                    console.log(err);
                    return null;
                });
        });
    };

    renderImage = () => (
        <div className="background-upload">
            <small className="background-small background-upload--title">Фон</small>
            <div className="background-upload--input">
                {this.state.filename &&
                <div className="background-upload--preview">
                    <img
                        src={`${staticUrl}/${this.state.filename}`}
                        className="background-upload--image"
                        alt={this.state.title}
                    />
                    <IconButton
                        className="background-upload--image-remove"
                        style={{ padding: 0, width: 24, height: 24 }}
                        onClick={this.removeFile}
                    >
                        <IconRemove color="#6c6c6c" hoverColor="#542376" />
                    </IconButton>
                </div>
                }
                <div className="background-upload--button">
                    {this.state.filename &&
                    <small className="background-small background-upload--change">Заменить изображение</small>
                    }
                    <IconContentAdd />
                    <IconButton
                        containerElement="label"
                        style={{ maxWidth: 12, height: 42, padding: 9 }}
                        className="btn__hover_empty"
                    >
                        <IconPhoto color="#46bc98" hoverColor="#542376" />
                        <input
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            onChange={e => this.uploadFile(e)}
                        />
                    </IconButton>
                </div>
            </div>
        </div>
    );

    render() {
        return (
            <section>
                <Paper
                    style={{
                        ...paperStyle.mainItem,
                        paddingTop: 5,
                        paddingBottom: 0,
                        height: '88vh',
                    }}
                >
                    <header
                        style={{
                            paddingTop: 5,
                            paddingBottom: 0,
                            ...containerHeader.header,
                            marginBottom: 5,
                            alignItems: 'none',
                        }}
                    >
                        <h3 style={{ ...styles.headerTitle, marginTop: 30 }}>Фон</h3>
                    </header>
                    <div>
                        <small className="background-small background-attention--title">Внимание</small>
                        <div className="background-attention--text">
                            Размер фона должен быть не менее 2560x1440 пикселей.
                        </div>
                    </div>
                    {this.renderImage()}
                </Paper>
            </section>
        );
    }
}

export default withRouter(createRefetchContainer(
    Background,
    graphql`
        fragment Background_viewer on Viewer @argumentDefinitions(
            page: {type: "Int!"},
            type: {type: "MediaFileTypeEnum"},
            states: {type:"[MediaFileStateType]"},
        ) {
            mediaFiles: mediaFilesPaginate(
                pageSize: 20, page: $page, type: $type, states: $states
            ) {
                mediaFiles {
                    id,
                    title,
                    filename,
                }
            }
        },
    `,
));



// WEBPACK FOOTER //
// src/components/background/Background.js